/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface V4ApplicationDealerportalGet$Params {
  appId?: string;
}

export function v4ApplicationDealerportalGet(http: HttpClient, rootUrl: string, params?: V4ApplicationDealerportalGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, v4ApplicationDealerportalGet.PATH, 'get');
  if (params) {
    rb.query('appId', params.appId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

v4ApplicationDealerportalGet.PATH = '/v4/application/dealerportal';
